import axios from "@/axios";
// import * as types from '../mutation-types';

export default {
    namespaced: true,
    
    state: {
    },

    actions: {
        fetchAll({ commit }) {
            return axios.get('Settings/ComputerSkills').then(({ data }) => {
                return data
            })
        },

        create({ commit }, { name }) {
            return axios.post('settings/ComputerSkills', name, { headers: { 'Content-Type': 'application/json' }}).then((data) => {
                return data
            })
        },

        update({ commit }, { name, id }) {
            return axios.put(`settings/ComputerSkills/${id}`, name, { headers: { 'Content-Type': 'application/json' }}).then((data) => {
                return data
            })
        },

        delete({ commit }, { id }) {
            return axios.delete(`settings/ComputerSkills/${id}`).then((data) => {
                return data
            })
        }


    },

    mutations: {
        // [types.STORE_LEAVES_OR_PERMISSIONS_TYPES](state, types) {
        //     state.types = types
        // }
    },

    getters: {

    }
}
